import type { Dictionnaire } from '../type';

export const lieux: Dictionnaire['lieux'] = {
  carte: 'Map of places',
  filtrer: 'Filter places',
  tout: 'All',
  rapproche: 'Zoom in to see places',
  recherche: 'Looking for places…',
  fermer: 'Close',
  appeler: 'Call',
  chercherSurLeWeb: 'Search the web',
  chercher: 'Search for a type of activity',
  exemple: 'Pool, stadium…',
  effacer: 'Clear',
  rienTrouve: 'Nothing found around here',
  creerUnEvenement: 'Create an event here',
  aimer: 'Like this place',
  nePlusAimer: 'Unlike this place',
  familles: {
    restos: 'Food',
    sorties: 'Going out',
    sport: 'Sport',
    culture: 'Culture',
    nature: 'Nature',
    commerces: 'Shops',
  },
  categories: {
    Restaurant: 'Restaurant',
    Cafe: 'Café',
    Bakery: 'Bakery',
    Nightlife: 'Bar',
    Brewery: 'Brewery',
    Winery: 'Winery',
    Distillery: 'Distillery',
    MovieTheater: 'Cinema',
    Theater: 'Theatre',
    MusicVenue: 'Concert venue',
    Bowling: 'Bowling',
    MiniGolf: 'Mini golf',
    GoKart: 'Go-karting',
    AmusementPark: 'Theme park',
    Stadium: 'Stadium',
    Soccer: 'Football',
    Tennis: 'Tennis',
    Basketball: 'Basketball',
    Swimming: 'Swimming pool',
    Volleyball: 'Volleyball',
    Golf: 'Golf',
    Skating: 'Ice rink',
    RockClimbing: 'Climbing',
    SkatePark: 'Skate park',
    FitnessCenter: 'Gym',
    Museum: 'Museum',
    Landmark: 'Landmark',
    Castle: 'Castle',
    Fortress: 'Fort',
    NationalMonument: 'National monument',
    Library: 'Library',
    Planetarium: 'Planetarium',
    Aquarium: 'Aquarium',
    Zoo: 'Zoo',
    Park: 'Park',
    Beach: 'Beach',
    Hiking: 'Hiking',
    NationalPark: 'National park',
    Marina: 'Marina',
    Store: 'Shop',
    FoodMarket: 'Market',
  },
};
